import * as React from "react";

function LeftPaginateArrow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="29" height="29" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="29" height="29" rx="3.5" stroke="#2AC769" />
      <path
        d="M11.46 15.71L17.12 21.36C17.213 21.4537 17.3236 21.5281 17.4454 21.5789C17.5673 21.6296 17.698 21.6558 17.83 21.6558C17.962 21.6558 18.0927 21.6296 18.2146 21.5789C18.3365 21.5281 18.4471 21.4537 18.54 21.36C18.7263 21.1726 18.8308 20.9191 18.8308 20.655C18.8308 20.3908 18.7263 20.1373 18.54 19.95L13.59 14.95L18.54 9.99996C18.7263 9.8126 18.8308 9.55915 18.8308 9.29496C18.8308 9.03078 18.7263 8.77733 18.54 8.58996C18.4474 8.49548 18.337 8.42031 18.2151 8.36881C18.0932 8.31731 17.9623 8.29051 17.83 8.28996C17.6977 8.29051 17.5668 8.31731 17.445 8.36881C17.3231 8.42031 17.2126 8.49548 17.12 8.58996L11.46 14.24C11.3585 14.3336 11.2775 14.4473 11.2221 14.5738C11.1667 14.7003 11.1381 14.8369 11.1381 14.975C11.1381 15.1131 11.1667 15.2497 11.2221 15.3762C11.2775 15.5027 11.3585 15.6163 11.46 15.71Z"
        fill="#2AC769"
      />
    </svg>
  );
}

export default LeftPaginateArrow;
